import axios from 'axios';
import { EventBus } from '../event/event-bus.js';
import router from '.././router';

const apiUrl = `${window.location.origin}/api`;

const client = axios.create({
    baseURL: apiUrl,
    json: true
})

export default {
    async execute(method, resource, data, accessToken) {
        return await client({
            method,
            url: resource,
            data,
            headers: {
                Authorization: `Bearer ${accessToken}`
            }
        }).then(req => {
            if (method === "post" || method === "put" || method === "delete") {
                EventBus.$emit('emit-success');
            }
            return req.data
        }).catch((error) => {
            if (error.response) {
                if (error.response.status === 403) {
                    router.push({ name: 'Unauthorized' });
                    return;
                } else if (error.response.status === 401) {
                    location.reload();
                    return;
                }
            }
            EventBus.$emit('emit-error', error.response.data);
        })
    },

    //CREATE CHART
    async createLineChart(request, accessToken) {
        return await this.execute('post', `/chart/line`, request, accessToken);
    },
    async createWordcloudChart(request, accessToken) {
        return await this.execute('post', `/chart/wordcloud`, request, accessToken);
    },
    async createPieChart(request, accessToken) {
        return await this.execute('post', `/chart/pie`, request, accessToken);
    },
    async createTableChart(request, accessToken) {
        return await this.execute('post', `/chart/table`, request, accessToken);
    },
    //GET CHART DETAILS
    async searchMyCharts(searchText, pageNo, pageSize, accessToken) {
        return await this.execute('get', `/chart?searchText=${searchText}&pageNo=${pageNo}&pageSize=${pageSize}`, null, accessToken);
    },
    async searchTemplateCharts(searchText, pageNo, pageSize, accessToken) {
        return await this.execute('get', `/chart/template?searchText=${searchText}&pageNo=${pageNo}&pageSize=${pageSize}`, null, accessToken);
    },
    async getWordCloudChartDetailsById(id, accessToken) {
        return await this.execute('get', `/chart/wordcloud/detail/${id}`, null, accessToken);
    },
    async getLineChartDetailsById(id, accessToken) {
        return await this.execute('get', `/chart/line/detail/${id}`, null, accessToken);
    },
    async getPieChartDetailsById(id, accessToken) {
        return await this.execute('get', `/chart/pie/detail/${id}`, null, accessToken);
    },
    async getTableChartDetailsById(id, accessToken) {
        return await this.execute('get', `/chart/table/detail/${id}`, null, accessToken);
    },
    //UPDATE CHART
    async updateLineChart(request, accessToken) {
        return await this.execute('put', `/chart/line`, request, accessToken);
    },
    async updateWordcloudChart(request, accessToken) {
        return await this.execute('put', `/chart/wordcloud`, request, accessToken);
    },
    async updatePieChart(request, accessToken) {
        return await this.execute('put', `/chart/pie`, request, accessToken);
    },
    async updateTableChart(request, accessToken) {
        return await this.execute('put', `/chart/table`, request, accessToken);
    },
}
